import React, { useEffect, useState, useContext } from 'react';
import { connect } from 'react-redux';
import {
	Row,
	Col,
	Card,
	Result,
	Input,
	Divider,
	Typography,
	notification,
	Button,
	Space,
} from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import {
	XThemeForm,
	XThemeRadio,
	XThemeInputText,
	XThemeNextPrevBtn,
} from '../../styles/GlobalThemeStyle';
// actions
import {
	addPayerConfigurationApi,
	addPayerConfigurationReset,
} from '../../actions/addPayerConfigurationAction';

import {
	editPayerConfigurationApi,
	editPayerConfigurationReset,
} from '../../actions/editPayerConfigurationAction';

import { checkModulePermissions, truncateString } from '../../utils/helper';
import { dateFilters } from '../../utils/constants';
import HeaderFile from '../../components/Header/HeaderFile';
import DataTable from '../../components/DataTable/DataTable';
import Header from '../../components/Header/Header';
import { XButtonImg } from '../Manage/ManageStyle';
import { filterByLabel } from '../../utils/formFunctions';
import { FormDataContext } from './PayerConfigurationForm';
import { XTheme2Button } from '../../styles/GlobalThemeStyleCQ';
const { Text, Link } = Typography;

const Step4 = (props) => {
	const navigate = useNavigate();

	const {
		addPayerConfiguration,
		addPayerConfigurationState,
		addPayerConfigurationReset,
		editPayerConfiguration,
		editPayerConfigurationReset,
		editPayerConfigurationState,
	} = props;

	const { form, formDataState, currentState, editModeState } =
		useContext(FormDataContext);
	const [createConfigurations, setCreateConfigurations] = useState(false);

	useEffect(() => {
		if (editPayerConfigurationState.apiState == 'success') {
			notification.success({
				message: editPayerConfigurationState.message,
			});
			editPayerConfigurationReset();
		}
	}, [editPayerConfigurationState]);

	const handlePrev = () => {
		currentState.setCurrent((old) => {
			return old - 1;
		});
	};

	const handleSubmit = () => {
		form.validateFields([
			'part_b_drugs-rc-organization_determination-timeline',
			'part_b_drugs-rc-organization_determination-timeline_type',
			'part_b_drugs-rc-organization_determination-in_process',
			'part_b_drugs-rc-organization_determination-at_risk',
			'part_b_drugs-rc-organization_determination-escalation',
			'part_b_drugs-rc-organization_determination-untimely',
			'part_b_drugs-rc-first_appeal-timeline',
			'part_b_drugs-rc-first_appeal-timeline_type',
			'part_b_drugs-rc-first_appeal-in_process',
			'part_b_drugs-rc-first_appeal-at_risk',
			'part_b_drugs-rc-first_appeal-escalation',
			'part_b_drugs-rc-first_appeal-untimely',
			'part_b_drugs-rc-second_appeal-timeline',
			'part_b_drugs-rc-second_appeal-timeline_type',
			'part_b_drugs-rc-second_appeal-in_process',
			'part_b_drugs-rc-second_appeal-at_risk',
			'part_b_drugs-rc-second_appeal-escalation',
			'part_b_drugs-rc-second_appeal-untimely',
			'part_b_drugs-rc-third_appeal-timeline',
			'part_b_drugs-rc-third_appeal-timeline_type',
			'part_b_drugs-rc-third_appeal-in_process',
			'part_b_drugs-rc-third_appeal-at_risk',
			'part_b_drugs-rc-third_appeal-escalation',
			'part_b_drugs-rc-third_appeal-untimely',
			'part_b_drugs-rc-fourth_appeal-timeline',
			'part_b_drugs-rc-fourth_appeal-timeline_type',
			'part_b_drugs-rc-fourth_appeal-in_process',
			'part_b_drugs-rc-fourth_appeal-at_risk',
			'part_b_drugs-rc-fourth_appeal-escalation',
			'part_b_drugs-rc-fourth_appeal-untimely',
			'part_b_drugs-rc-judicial_review-timeline',
			'part_b_drugs-rc-judicial_review-timeline_type',
			'part_b_drugs-rc-judicial_review-in_process',
			'part_b_drugs-rc-judicial_review-at_risk',
			'part_b_drugs-rc-judicial_review-escalation',
			'part_b_drugs-rc-judicial_review-untimely',
			'part_b_drugs-ma_standard-organization_determination-timeline',
			'part_b_drugs-ma_standard-organization_determination-timeline_type',
			'part_b_drugs-ma_standard-organization_determination-in_process',
			'part_b_drugs-ma_standard-organization_determination-at_risk',
			'part_b_drugs-ma_standard-organization_determination-untimely',
			'part_b_drugs-ma_standard-first_appeal-timeline',
			'part_b_drugs-ma_standard-first_appeal-timeline_type',
			'part_b_drugs-ma_standard-first_appeal-in_process',
			'part_b_drugs-ma_standard-first_appeal-at_risk',
			'part_b_drugs-ma_standard-first_appeal-untimely',
			'part_b_drugs-ma_standard-second_appeal-timeline',
			'part_b_drugs-ma_standard-second_appeal-timeline_type',
			'part_b_drugs-ma_standard-second_appeal-in_process',
			'part_b_drugs-ma_standard-second_appeal-at_risk',
			'part_b_drugs-ma_standard-second_appeal-untimely',
			'part_b_drugs-ma_standard-third_appeal-timeline',
			'part_b_drugs-ma_standard-third_appeal-timeline_type',
			'part_b_drugs-ma_standard-third_appeal-in_process',
			'part_b_drugs-ma_standard-third_appeal-at_risk',
			'part_b_drugs-ma_standard-third_appeal-untimely',
			'part_b_drugs-ma_standard-fourth_appeal-timeline',
			'part_b_drugs-ma_standard-fourth_appeal-timeline_type',
			'part_b_drugs-ma_standard-fourth_appeal-in_process',
			'part_b_drugs-ma_standard-fourth_appeal-at_risk',
			'part_b_drugs-ma_standard-fourth_appeal-untimely',
			'part_b_drugs-ma_standard-judicial_review-timeline',
			'part_b_drugs-ma_standard-judicial_review-timeline_type',
			'part_b_drugs-ma_standard-judicial_review-in_process',
			'part_b_drugs-ma_standard-judicial_review-at_risk',
			'part_b_drugs-ma_standard-judicial_review-untimely',
		])
			.then((values) => {
				formDataState.setFormData((old) => {
					return { ...old, ...values };
				});
				setCreateConfigurations(true);
			})
			.catch((error) => {
				return;
			});
	};

	useEffect(() => {
		if (createConfigurations) {
			addPayerConfiguration(formDataState.formData);
		}
	}, [createConfigurations]);

	useEffect(() => {
		if (addPayerConfigurationState.apiState == 'success') {
			addPayerConfigurationReset();
			setCreateConfigurations(false);
			navigate('/payer-configuration');
		}
	}, [addPayerConfigurationState]);

	const handleUpdate = () => {
		form.validateFields([
			'part_b_drugs-rc-organization_determination-timeline',
			'part_b_drugs-rc-organization_determination-timeline_type',
			'part_b_drugs-rc-organization_determination-in_process',
			'part_b_drugs-rc-organization_determination-at_risk',
			'part_b_drugs-rc-organization_determination-escalation',
			'part_b_drugs-rc-organization_determination-untimely',
			'part_b_drugs-rc-first_appeal-timeline',
			'part_b_drugs-rc-first_appeal-timeline_type',
			'part_b_drugs-rc-first_appeal-in_process',
			'part_b_drugs-rc-first_appeal-at_risk',
			'part_b_drugs-rc-first_appeal-escalation',
			'part_b_drugs-rc-first_appeal-untimely',
			'part_b_drugs-rc-second_appeal-timeline',
			'part_b_drugs-rc-second_appeal-timeline_type',
			'part_b_drugs-rc-second_appeal-in_process',
			'part_b_drugs-rc-second_appeal-at_risk',
			'part_b_drugs-rc-second_appeal-escalation',
			'part_b_drugs-rc-second_appeal-untimely',
			'part_b_drugs-rc-third_appeal-timeline',
			'part_b_drugs-rc-third_appeal-timeline_type',
			'part_b_drugs-rc-third_appeal-in_process',
			'part_b_drugs-rc-third_appeal-at_risk',
			'part_b_drugs-rc-third_appeal-escalation',
			'part_b_drugs-rc-third_appeal-untimely',
			'part_b_drugs-rc-fourth_appeal-timeline',
			'part_b_drugs-rc-fourth_appeal-timeline_type',
			'part_b_drugs-rc-fourth_appeal-in_process',
			'part_b_drugs-rc-fourth_appeal-at_risk',
			'part_b_drugs-rc-fourth_appeal-escalation',
			'part_b_drugs-rc-fourth_appeal-untimely',
			'part_b_drugs-rc-judicial_review-timeline',
			'part_b_drugs-rc-judicial_review-timeline_type',
			'part_b_drugs-rc-judicial_review-in_process',
			'part_b_drugs-rc-judicial_review-at_risk',
			'part_b_drugs-rc-judicial_review-escalation',
			'part_b_drugs-rc-judicial_review-untimely',
			'part_b_drugs-ma_standard-organization_determination-timeline',
			'part_b_drugs-ma_standard-organization_determination-timeline_type',
			'part_b_drugs-ma_standard-organization_determination-in_process',
			'part_b_drugs-ma_standard-organization_determination-at_risk',
			'part_b_drugs-ma_standard-organization_determination-untimely',
			'part_b_drugs-ma_standard-first_appeal-timeline',
			'part_b_drugs-ma_standard-first_appeal-timeline_type',
			'part_b_drugs-ma_standard-first_appeal-in_process',
			'part_b_drugs-ma_standard-first_appeal-at_risk',
			'part_b_drugs-ma_standard-first_appeal-untimely',
			'part_b_drugs-ma_standard-second_appeal-timeline',
			'part_b_drugs-ma_standard-second_appeal-timeline_type',
			'part_b_drugs-ma_standard-second_appeal-in_process',
			'part_b_drugs-ma_standard-second_appeal-at_risk',
			'part_b_drugs-ma_standard-second_appeal-untimely',
			'part_b_drugs-ma_standard-third_appeal-timeline',
			'part_b_drugs-ma_standard-third_appeal-timeline_type',
			'part_b_drugs-ma_standard-third_appeal-in_process',
			'part_b_drugs-ma_standard-third_appeal-at_risk',
			'part_b_drugs-ma_standard-third_appeal-untimely',
			'part_b_drugs-ma_standard-fourth_appeal-timeline',
			'part_b_drugs-ma_standard-fourth_appeal-timeline_type',
			'part_b_drugs-ma_standard-fourth_appeal-in_process',
			'part_b_drugs-ma_standard-fourth_appeal-at_risk',
			'part_b_drugs-ma_standard-fourth_appeal-untimely',
			'part_b_drugs-ma_standard-judicial_review-timeline',
			'part_b_drugs-ma_standard-judicial_review-timeline_type',
			'part_b_drugs-ma_standard-judicial_review-in_process',
			'part_b_drugs-ma_standard-judicial_review-at_risk',
			'part_b_drugs-ma_standard-judicial_review-untimely',
		])
			.then((values) => {
				formDataState.setFormData((old) => {
					return { ...old, ...values };
				});

				editPayerConfiguration({
					update_type: 'part_b_drugs',
					id: formDataState.formData.id,
					...values,
				});
			})
			.catch((error) => {
				return;
			});
	};

	return (
		<>
			<XThemeForm
				form={form}
				name="timelineConfigFrom"
				layout="vertical"
				autoComplete="off"
			>
				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<p className="modalPara1 text-dark m-0">
							<strong>RC</strong>
						</p>
					</Col>
				</Row>
				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Organization Determination</Text>
						</Divider>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-organization_determination-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="part_b_drugs-rc-organization_determination-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-organization_determination-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-organization_determination-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="part_b_drugs-rc-organization_determination-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-organization_determination-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="part_b_drugs-rc-organization_determination-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-organization_determination-escalation"
							label="Escalation"
							rules={[
								{
									required: true,
									message: 'Please enter Escalation start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Escalation Start"
								name="part_b_drugs-rc-organization_determination-escalation"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-organization_determination-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="part_b_drugs-rc-organization_determination-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>First Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-first_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="part_b_drugs-rc-first_appeal-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-first_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-first_appeal-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="part_b_drugs-rc-first_appeal-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-first_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="part_b_drugs-rc-first_appeal-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-first_appeal-escalation"
							label="Escalation"
							rules={[
								{
									required: true,
									message: 'Please enter Escalation start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Escalation Start"
								name="part_b_drugs-rc-first_appeal-escalation"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-first_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="part_b_drugs-rc-first_appeal-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Second Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-second_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="part_b_drugs-rc-second_appeal-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-second_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-second_appeal-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="part_b_drugs-rc-second_appeal-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-second_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="part_b_drugs-rc-second_appeal-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-second_appeal-escalation"
							label="Escalation"
							rules={[
								{
									required: true,
									message: 'Please enter Escalation start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Escalation Start"
								name="part_b_drugs-rc-second_appeal-escalation"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-second_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="part_b_drugs-rc-second_appeal-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Third Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-third_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="part_b_drugs-rc-third_appeal-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-third_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-third_appeal-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="part_b_drugs-rc-third_appeal-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-third_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="part_b_drugs-rc-third_appeal-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-third_appeal-escalation"
							label="Escalation"
							rules={[
								{
									required: true,
									message: 'Please enter Escalation start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Escalation Start"
								name="part_b_drugs-rc-third_appeal-escalation"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-third_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="part_b_drugs-rc-third_appeal-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Fourth Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-fourth_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="part_b_drugs-rc-fourth_appeal-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-fourth_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-fourth_appeal-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="part_b_drugs-rc-fourth_appeal-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-fourth_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="part_b_drugs-rc-fourth_appeal-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-fourth_appeal-escalation"
							label="Escalation"
							rules={[
								{
									required: true,
									message: 'Please enter Escalation start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Escalation Start"
								name="part_b_drugs-rc-fourth_appeal-escalation"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-fourth_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="part_b_drugs-rc-fourth_appeal-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Judicial Review</Text>
						</Divider>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-judicial_review-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="part_b_drugs-rc-judicial_review-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-judicial_review-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-judicial_review-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="part_b_drugs-rc-judicial_review-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-judicial_review-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="part_b_drugs-rc-judicial_review-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-judicial_review-escalation"
							label="Escalation"
							rules={[
								{
									required: true,
									message: 'Please enter Escalation start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Escalation Start"
								name="part_b_drugs-rc-judicial_review-escalation"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-rc-judicial_review-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="part_b_drugs-rc-judicial_review-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)} className="mt-4">
					<Col xs={24}>
						<p className="modalPara1 text-dark m-0">
							<strong>MA Standard</strong>
						</p>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Organization Determination</Text>
						</Divider>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-organization_determination-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="part_b_drugs-ma_standard-organization_determination-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-organization_determination-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-organization_determination-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="part_b_drugs-ma_standard-organization_determination-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-organization_determination-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="part_b_drugs-ma_standard-organization_determination-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-organization_determination-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="part_b_drugs-ma_standard-organization_determination-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>First Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-first_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="part_b_drugs-ma_standard-first_appeal-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-first_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-first_appeal-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="part_b_drugs-ma_standard-first_appeal-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-first_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="part_b_drugs-ma_standard-first_appeal-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-first_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="part_b_drugs-ma_standard-first_appeal-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Second Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-second_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="part_b_drugs-ma_standard-second_appeal-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-second_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-second_appeal-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="part_b_drugs-ma_standard-second_appeal-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-second_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="part_b_drugs-ma_standard-second_appeal-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-second_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="part_b_drugs-ma_standard-second_appeal-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Third Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-third_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="part_b_drugs-ma_standard-third_appeal-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-third_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-third_appeal-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="part_b_drugs-ma_standard-third_appeal-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-third_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="part_b_drugs-ma_standard-third_appeal-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-third_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="part_b_drugs-ma_standard-third_appeal-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Fourth Appeal</Text>
						</Divider>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-fourth_appeal-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="part_b_drugs-ma_standard-fourth_appeal-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-fourth_appeal-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-fourth_appeal-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="part_b_drugs-ma_standard-fourth_appeal-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-fourth_appeal-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="part_b_drugs-ma_standard-fourth_appeal-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-fourth_appeal-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="part_b_drugs-ma_standard-fourth_appeal-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={(15, 15)}>
					<Col xs={24}>
						<Divider
							orientation="left"
							orientationMargin="0"
							className="mb-4"
						>
							<Text>Judicial Review</Text>
						</Divider>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-judicial_review-timeline"
							label="Timeline"
							rules={[
								{
									required: true,
									message: 'Please enter timeline',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Timeline"
								name="part_b_drugs-ma_standard-judicial_review-timeline"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-judicial_review-timeline_type"
							label="Timeline Type"
							rules={[
								{
									required: true,
									message: 'Please select timeline type',
								},
							]}
						>
							<XThemeRadio.Group size="large" value={'days'}>
								<XThemeRadio value={'hours'}>Hours</XThemeRadio>
								<XThemeRadio value={'days'}>Days</XThemeRadio>
							</XThemeRadio.Group>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-judicial_review-in_process"
							label="In Progress"
							rules={[
								{
									required: true,
									message: 'Please enter In progress start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter In Progress Start"
								name="part_b_drugs-ma_standard-judicial_review-in_process"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-judicial_review-at_risk"
							label="At Risk"
							rules={[
								{
									required: true,
									message: 'Please enter At Risk start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter At Risk Start"
								name="part_b_drugs-ma_standard-judicial_review-at_risk"
							/>
						</XThemeForm.Item>
					</Col>
					<Col xs={24} md={8} lg={4}>
						<XThemeForm.Item
							className="drawerlabel"
							name="part_b_drugs-ma_standard-judicial_review-untimely"
							label="Untimely"
							rules={[
								{
									required: true,
									message: 'Please enter Untimely start',
								},
							]}
						>
							<XThemeInputText
								className="largeInputForms"
								size="large"
								placeholder="Enter Untimely Start"
								name="part_b_drugs-ma_standard-judicial_review-untimely"
							/>
						</XThemeForm.Item>
					</Col>
				</Row>

				<Row gutter={[15, 15]}>
					{editModeState.editMode ? (
						<Col xs={24} className="text-center text-md-end">
							<Space>
								<XTheme2Button
									className="noBackground"
									onClick={handlePrev}
								>
									<LeftOutlined />
									Previous
								</XTheme2Button>
								<Divider
									type="vertical"
									style={{
										height: '30px',
										marginInline: '20px',
									}}
									orientationMargin={1}
								/>
								<XTheme2Button onClick={handleUpdate}>
									Update
								</XTheme2Button>
							</Space>
						</Col>
					) : (
						<Col xs={24} className="text-end text-md-end">
							<Space>
								<XTheme2Button
									className="noBackground"
									onClick={handlePrev}
								>
									<LeftOutlined />
									Previous
								</XTheme2Button>

								<XTheme2Button onClick={handleSubmit}>
									Submit
								</XTheme2Button>
							</Space>
						</Col>
					)}
				</Row>
			</XThemeForm>
		</>
	);
};

const mapStateToProps = (state) => ({
	addPayerConfigurationState: state.addPayerConfiguration,
	editPayerConfigurationState: state.editPayerConfiguration,
});

const mapDispatchToProps = (dispatch) => ({
	addPayerConfiguration: (data) => dispatch(addPayerConfigurationApi(data)),
	addPayerConfigurationReset: () => dispatch(addPayerConfigurationReset()),
	editPayerConfiguration: (data) => dispatch(editPayerConfigurationApi(data)),
	editPayerConfigurationReset: () => dispatch(editPayerConfigurationReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Step4);
